import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { NavLink, Link } from 'react-router-dom';
import $ from 'jquery';

import '../styles/components/Header.css';
import { FloatingSubMenu } from './Menu/FloatingSubMenu';
import { ThemeContext } from './../containers/ThemeContext';

import logoV1RAGEdark from '../assets/images/icons/svg/logoV1RAGEdark.svg';
import logoV1RAGEwhite from '../assets/images/icons/svg/logoV1RAGEwhite.svg';

import offerLongtime from '../assets/icons-fleet/icon-offer-longtime.svg';
import offerSell from '../assets/icons-fleet/icon-offer-sell.svg';
import offerFleet from '../assets/icons-fleet/icon-offer-fleet.svg';

import fbLogo from '../assets/images/icons/svg/fb-grey.svg';
import instaLogo from '../assets/images/icons/svg/insta-grey.svg';

import arrowRightSmall from '../assets/images/icons/svg/arrow-small-orange.svg';

class Header extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showServices: false
        };

        this.doResize = null;
    }

    UNSAFE_componentWillUpdate(prevprops) {
        if (this.props.location.pathname !== prevprops.location.pathname) {
            this.setState({
                showServices: false
            });
        }
    }

    resizeDocument = () => {
        if ($(document).width() <= 767) {
            $('.header').hide(0);
            $('.header-mobile').show(0);
        } else {
            $('.header').show(0);
            $('.header-mobile').hide(0);
        }
    };

    setScrollMouseMargin = async () => {
        clearTimeout(this.doResize);

        const styleElem = document.head.appendChild(
            document.createElement('style')
        );

        this.doResize = setTimeout(() => {
            if ($('.section-contact .right-side').length === 1) {
                const fromLeft = $('.section-contact .right-side').offset()
                    .left;
                $('.mouse').css('left', fromLeft - 16 + 'px');
                $('.page-contact .hero').css(
                    'background-position-x',
                    fromLeft - 660 + 'px'
                );
                styleElem.innerHTML = `
          .line::before,
          .scroll::before,
          .scroll::after {
            left:${fromLeft}px
          }
        `;
            }
        }, 500);
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.defaultScrolled !== nextProps.defaultScrolled) {
            this.scrollDocument(nextProps.defaultScrolled);
        }

        if (this.props.location.pathname !== nextProps.location.pathname) {
            this.setScrollMouseMargin();
            this.scrollDocument();
        }
    }

    scrollDocument = defaultScrolled2 => {
        const defaultScrolled =
            defaultScrolled2 === true || defaultScrolled2 === false
                ? defaultScrolled2
                : this.props.defaultScrolled;

        const scrollTop = $(window).scrollTop();

        if (defaultScrolled) {
            $('.header, .header-services').addClass('scroll-down');

            $('.header-mobile')
                .addClass('scroll-down')
                .css('background-position', '');
        } else if ($(document).width() <= 767) {
            const headerMobileElem = $('.header-mobile');
            const headerMobileLogoElem = $('.header-mobile .header-logo img');
            if (scrollTop <= 200) {
                const opacity = (scrollTop / 200).toPrecision(2);
                headerMobileElem.css(
                    'background-color',
                    `rgba(0,0,0,${opacity})`
                );
                if (scrollTop < 100) {
                    headerMobileElem.removeClass('scroll-down');
                    if ($('.header-mobile').hasClass('header--dark')) {
                        headerMobileLogoElem.attr('src', logoV1RAGEdark);
                    }
                } else {
                    headerMobileElem.addClass('scroll-down');
                    if ($('.header-mobile').hasClass('header--dark')) {
                        headerMobileLogoElem.attr('src', logoV1RAGEwhite);
                    }
                }
            } else {
                if (
                    headerMobileElem.css('background-color') !== 'rgb(0, 0, 0)'
                ) {
                    headerMobileElem.css('background-color', `rgb(0,0,0)`);
                }
            }
        }

        if (!defaultScrolled) {
            if (
                scrollTop >
                parseInt($('.header').css('margin-top'), 10) +
                    $('.header').outerHeight()
            ) {
                $('.header, .header-mobile, .header-services').addClass(
                    'scroll-down'
                );
            } else {
                $('.header, .header-mobile, .header-services').removeClass(
                    'scroll-down'
                );
            }
        }
    };

    openCloseMobileMenu() {
        $('.hamburger-menu').toggleClass('animate');
        $('.header-mobile').toggleClass('menu-opened');
        $('body').toggleClass('fixed-position');
    }

    onMouseOver(elemName) {
        // console.log('elemName', elemName);
    }

    showHideServices = () => {
        this.setState(
            {
                showServices: !this.state.showServices
            },
            () => {
                this.scrollDocument();
            }
        );
    };

    componentDidMount() {
        window.addEventListener('scroll', this.scrollDocument);
        window.addEventListener('resize', this.resizeDocument);
        window.addEventListener('resize', this.setScrollMouseMargin);
        this.resizeDocument();
        this.setScrollMouseMargin();

        $(document).ready(() => {
            this.scrollDocument();

            $('.burger-container').click(() => {
                this.openCloseMobileMenu();
            });
            $('.header-mobile .menu-item').click(() => {
                this.openCloseMobileMenu();
            });
            const windowHeight = $(window).height() / 3;
            $(window).scroll(function() {
                const element = $('#hero-element');
                if (element !== null && element !== undefined) {
                    const heightFromTop = (
                        $(this).scrollTop() - windowHeight
                    ).toPrecision(3);
                    var styleElem = document.head.appendChild(
                        document.createElement('style')
                    );
                    styleElem.innerHTML = `.scroll:after {top: ${heightFromTop}px;}`;
                    $('.mouse').css('top', heightFromTop + 'px');
                    if (heightFromTop < 0) {
                        styleElem.innerHTML = `
              .scroll:after {
                top: ${0}px
              }`;
                        $('.mouse').css('top', 0 + 'px');
                    }
                }
            });
            $('.mouse').click(function() {
                $('html, body').animate({ scrollTop: 0 }, 'slow');
            });
        });
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.scrollDocument);
        window.removeEventListener('resize', this.resizeDocument);
        window.removeEventListener('resize', this.setScrollMouseMargin);
    }

    render() {
        const context = this.context;
        const white = context.headerColor === 'white';
        const defaultScrolled = this.props.defaultScrolled;

        return (
            <header>
                <div
                    className={`header ${
                        white ? 'header--white' : 'header--dark'
                    } ${defaultScrolled ? 'scroll-down' : ''}`}
                >
                    <div className="container">
                        <div className="row">
                            <ul className="header-menu" role="navigation">
                                <li>
                                    {/* <NavLink
                    className="title"
                    activeClassName="active"
                    to="/oferta"
                  >
                    Oferta
                  </NavLink> */}
                                    <span
                                        onClick={this.showHideServices}
                                        className={`link ${
                                            this.state.showServices
                                                ? 'active'
                                                : ''
                                        }`}
                                    >
                                        Usługi
                                        <img
                                            src={arrowRightSmall}
                                            alt="Icon arrow right orange"
                                            className="arrow-icon"
                                        />
                                    </span>
                                </li>
                                <li>
                                    <NavLink
                                        className="title"
                                        activeClassName="active"
                                        to="/flota"
                                    >
                                        Flota
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink
                                        className="title"
                                        activeClassName="active"
                                        to="/motoconcierge"
                                    >
                                        motoconcierge
                                    </NavLink>
                                </li>
                            </ul>
                            <Link className="header-logo" to="/">
                                <img
                                    src={
                                        white ? logoV1RAGEwhite : logoV1RAGEdark
                                    }
                                    alt="V1RAGE logo"
                                />
                            </Link>
                            <address className="header-contact">
                                <NavLink
                                    className="title"
                                    activeClassName="active"
                                    to="/kontakt"
                                >
                                    Kontakt
                                </NavLink>
                                <a
                                    className="margin-left"
                                    href="tel:+48664136106"
                                >
                                    + 48 664 136 106
                                </a>
                                <div className="social-icons footer-social-icons">
                                    <ul>
                                        <li>
                                            <a
                                                href="https://www.facebook.com/v1rage/"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <img
                                                    className="svg"
                                                    style={{ display: 'none' }}
                                                    src={fbLogo}
                                                    alt="Facebook logo white"
                                                />
                                            </a>
                                        </li>
                                        {/* <li>
                  <a href="https://www.facebook.com/?ref=logo" target="_blank" rel="noopener noreferrer">
                    <img className="svg" style={{display: 'none'}} src={ytLogo} alt="Youtube logo white" />
                  </a>
                </li>
                <li>
                  <a href="https://www.facebook.com/?ref=logo" target="_blank" rel="noopener noreferrer">
                    <img className="svg" style={{display: 'none'}} src={twLogo} alt="Twitter logo white" />
                  </a>
                </li> */}
                                        <li>
                                            <a
                                                href="https://www.instagram.com/v1ragecom/"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <img
                                                    className="svg"
                                                    style={{ display: 'none' }}
                                                    src={instaLogo}
                                                    alt="Instagram logo white"
                                                />
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </address>
                        </div>
                    </div>
                </div>

                <div
                    className={`header-mobile ${
                        white ? 'header--white' : 'header--dark'
                    }`}
                >
                    <div className="burger-container">
                        <div id="burger">
                            <div className="bar topBar" />
                            <div className="bar btmBar" />
                        </div>
                    </div>
                    <Link className="header-logo" to="/">
                        <img
                            src={white ? logoV1RAGEwhite : logoV1RAGEdark}
                            alt="V1RAGE logo"
                        />
                    </Link>
                    <address className="header-contact">
                        <a href="tel:+48664136106">+ 48 664 136 106</a>
                    </address>
                    <ul className="menu">
                        <li className="menu-item">
                            <NavLink to="/">Strona główna</NavLink>
                        </li>
                        <li className="menu-item">
                            <NavLink
                                className="title"
                                activeClassName="active"
                                to="/flota"
                            >
                                Flota
                            </NavLink>
                        </li>
                        <li className="menu-item">
                            <NavLink
                                className="title"
                                activeClassName="active"
                                to="/motoconcierge"
                            >
                                Motoconcierge
                            </NavLink>
                        </li>
                        <li className="menu-item">
                            <NavLink
                                className="title"
                                activeClassName="active"
                                to="/oferta/wynajem-dlugookresowy"
                            >
                                Wynajem
                            </NavLink>
                        </li>
                        <li className="menu-item">
                            <NavLink
                                className="title"
                                activeClassName="active"
                                to="/oferta/sprzedaz"
                            >
                                Zakup
                            </NavLink>
                        </li>
                        <li className="menu-item">
                            <NavLink
                                className="title"
                                activeClassName="active"
                                to="/oferta/obsluga-flot"
                            >
                                Obsługa flot
                            </NavLink>
                        </li>
                        {/* <li className="menu-item">
              <NavLink className="title" activeClassName="active" to="/o-marce">
                O marce
              </NavLink>
            </li> */}
                        {/* <li className="menu-item">
              <NavLink
                className="title"
                activeClassName="active"
                to="/motoconcierge"
              >
                Motoconcierge
              </NavLink>
            </li> */}
                        <li className="menu-item">
                            <NavLink
                                className="title"
                                activeClassName="active"
                                to="/faq"
                            >
                                Faq
                            </NavLink>
                        </li>
                        <li className="menu-item">
                            <NavLink
                                className="title"
                                activeClassName="active"
                                to="/regulamin"
                            >
                                Regulamin
                            </NavLink>
                        </li>
                        {/* <li className="menu-item">
              <NavLink className="title" activeClassName="active" to="/blog">
                Nasz blog
              </NavLink>
            </li> */}
                        <li className="menu-item">
                            <NavLink
                                className="title"
                                activeClassName="active"
                                to="/kontakt"
                            >
                                Kontakt
                            </NavLink>
                        </li>
                    </ul>
                </div>

                {this.state.showServices && (
                    <FloatingSubMenu
                        className={`header-services ${
                            defaultScrolled ? 'scroll-down' : ''
                        }`}
                    >
                        <ul className="">
                            <li className=" long">
                                <Link
                                    className="btn-offer"
                                    to="/oferta/wynajem-dlugookresowy"
                                >
                                    <img
                                        src={offerLongtime}
                                        alt="Icon"
                                        className="icon-offer"
                                    />
                                    <h5>Wynajem</h5>
                                </Link>
                            </li>

                            <li className=" sell">
                                <Link
                                    className="btn-offer"
                                    to="/oferta/sprzedaz"
                                >
                                    <img
                                        src={offerSell}
                                        alt="Icon"
                                        className="icon-offer"
                                    />
                                    <h5>Zakup</h5>
                                </Link>
                            </li>
                            <li className=" sell">
                                <Link
                                    className="btn-offer"
                                    to="/oferta/obsluga-flot"
                                >
                                    <img
                                        src={offerFleet}
                                        alt="Icon"
                                        className="icon-offer"
                                    />
                                    <h5>Obsługa flot</h5>
                                </Link>
                            </li>
                        </ul>
                    </FloatingSubMenu>
                )}
            </header>
        );
    }
}

Header.contextType = ThemeContext;

export default withRouter(Header);
